export const MOBILE_BREAKPOINT = 768;

/** Max character length for truncated track/album descriptions before "show more" */
export const DESCRIPTION_PREVIEW_LIMIT = 180;

/** How many tracks the upload/master wizard accepts in a single batch */
export const MAX_TRACK_UPLOAD_BATCH = 20;

/** How many of a batch's files are uploaded to S3 at the same time */
export const TRACK_UPLOAD_CONCURRENCY = 3;
